import { chakra, Container, useMultiStyleConfig } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { HeaderSearch } from "src/components/Search/HeaderSearch";
import { useSearchContext } from "src/components/Search/hooks";
import { SearchButton } from "src/components/Search/shared";
import { useTranslatedString } from "src/i18n/hooks";

type DesktopMenuProps = {
	logo: ReactNode;
	children: ReactNode;
};

export const DesktopMenu: React.FC<DesktopMenuProps> = ({ logo, children }) => {
	const styles = useMultiStyleConfig("DesktopMenu");
	const { showSearch, toggleSearch } = useSearchContext();
	const t = useTranslatedString();

	return (
		<chakra.div __css={styles.wrapper}>
			<Container maxW="container.xl" sx={styles.inner}>
				{logo}
				<chakra.div __css={styles.children}>
					{children}
					<div className="flex items-center">
						<SearchButton />
					</div>
				</chakra.div>
			</Container>
			{showSearch && (
				<>
					<button
						className="bg-black/50 inset-0 fixed top-(--header-height) cursor-default"
						type="button"
						onClick={toggleSearch}
					>
						<span className="sr-only">{t("search.close")}</span>
					</button>
					<HeaderSearch />
				</>
			)}
		</chakra.div>
	);
};

// 🔬 TBD: Please evaluate
